export default __webpack_public_path__ + "static/media/Acidic Sludge.f2460e37.png";